import React from "react";
import "./User.scss";

interface UserHeadingProps {
    text: React.ReactNode;
    onClose?: () => void;
    onHelp?: () => void;
    className?: string;
}

export default function UserHeading({ text, onClose, onHelp, className = '' }: UserHeadingProps) {
    return (
        <div className={`user_heading ${className}`}>
            {onHelp && (
                <div className="status_info_icon no-select" onClick={onHelp}>ⓘ</div>
            )}
            <div>{text}</div>
            {onClose && <div className="a user_heading_icon no-select" onClick={onClose}>×</div>}
        </div>
    );
}